<template>
  <div class="video-select-box">

  

    <a-button @click="show = true" type="dashed" :icon="'upload'">
      <template v-if="ids.length > 0"> 已选择{{ ids.length }}/{{ maxNum }}个视频</template>
      <template v-else>点击添加视频</template>
    </a-button>

    <a-tag @click="clearSelected" color="orange" v-if="ids.length > 0" style="margin-left:20px;cursor:pointer">
      点击清空所有视频
    </a-tag>
    
    <a-modal
      title="视频素材"
      centered
      :width="990"
      :mask-closable="false"
      :visible="show"
      :confirmLoading="false"
      :bodyStyle="{ paddingBottom: '10px' }"
      @ok="complete"
      @cancel="close"
    >

    <template>
      <div class="search-wrapper" ref="search" style="margin-top: -30px;">
          <div class="title">
              <a-icon type="search"/>
              数据筛选
          </div>
          <a-divider></a-divider>
          <a-space>
              <a-input allow-clear placeholder="名称" v-model="queryParam.name" />
              <a-input allow-clear placeholder="素材ID" v-model="queryParam.material_id"/>
              <a-range-picker :allowClear="false" v-model="queryParam.date" valueFormat="YYYY-MM-DD"/>
              <a-button type="primary" @click="search" title="点击回车直接查询" style="border:1px solid gold">查询 <span style="color:gold;font-size:10px"> (支持回车) </span></a-button>
              <a-button @click="resetSearch">重置</a-button>
              <byted-button type="success" @click="selectAll">全选</byted-button>
              <span v-if="media!='juliang'"> 总数量：{{video_total}}</span>
          </a-space>
      </div>
    </template>
    
    
      <div
        v-infinite-scroll="handleInfiniteOnLoad"
        :infinite-scroll-disabled="busy"
        :infinite-scroll-distance="100"
        class="video-select-wrapper"
      >
        <a-spin :spinning="loading" />
        <div class="list">
          <div class="empty-box" v-if="!loading && videos.length === 0">
            <a-empty />
          </div>
          <div
            class="item"
            v-for="video in videos"
            :key="video.id"
            @mouseenter="preview(video, $event)"
            @mouseleave="hidePreview(video)"
            @click="changeVideoId(video)"
          >
            <a-tooltip>
              <template slot="title">
                {{ video.filename.split('.mp4')[0] }}
              </template>

              <img :src="video.poster_url" :alt="video.name" :class="[
                videoSelected(video) ? 'active' : '',
                video.ratio === 1.7778 ? 'landscape' : ''
              ]"/>
              <div class="title">
                {{ video.filename.split('.mp4')[0] }}
                <a-tag color="red" class="video_sync_tag" v-if="media==='juliang' && !video.ratio ">尺寸不符合</a-tag>
                <a-tag color="red" class="video_sync_tag" v-if="media==='juliang' && video.inefficient && video.inefficient === true">低效</a-tag>
              </div>
            </a-tooltip>
          </div>
        </div>
      </div>


    </a-modal>

    <!-- 悬浮视频预览卡片（mounted 时移到 body 下，避免被 modal 层叠上下文遮挡） -->
    <div
      v-show="previewVisible && currentVideo"
      ref="previewCard"
      class="video-floating-preview"
      :style="previewCardStyle"
      @mouseenter="onCardMouseEnter"
      @mouseleave="onCardMouseLeave"
    >
      <video v-if="currentVideo" autoplay muted controls :src="currentVideo.url" />
    </div>
  </div>
</template>

<style lang="less" scoped>
@import 'VideoSelect';
</style>

<!-- 悬浮卡片样式非 scoped，因为元素会被移到 body 下 -->
<style lang="less">
.video-floating-preview {
  position: fixed;
  width: 320px;
  background: #000;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  z-index: 9999;

  video {
    width: 100%;
    display: block;
    max-height: calc(100vh - 20px);
    object-fit: contain;
  }
}
</style>

<script>
import VideoSelect from './VideoSelect'
export default VideoSelect
</script>
